import { useState, useCallback } from 'react'

export const useInput = (initialValue) => {
    const [value, setValue] = useState(initialValue)
    const onChange = useCallback((value) => {
        setValue(value)
    }, [])
    return [value, setValue, onChange]
}
